// extracted by css-extract-rspack-plugin
export default {"supportButton":"Fk_lD1BlIIeSE0j5"};